import { i18n, inject, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { NativeFlatButton } from "components/common/NativeFlatButton";
import authStore from "stores/AuthStore";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { safeWindowOpen } from "util/helpers";
import { TeamcardLinkageStore } from "./TeamcardLinkageStore";


const CustomButtonComponent = () => {
    const handleClickOpenHelpCenter = () => {
        const link = authStore.locale === "de" ? "https://www.sparkasse.at/business-virtualcards-george-help" : "https://www.sparkasse.at/business-virtualcards-george-help-en";
        safeWindowOpen(link);
    }

    const handleClickFinish = () => {
        const link = externalInterfaceStore.federatedLoginUrl;
        safeWindowOpen(link);
    }

    return (
        <pr.VFlex
            style={{
                bottom: 15,
                maxWidth: theme.MAX_APP_WIDTH,
                position: "fixed",
                width: "100%",
            }}
        >
            <pr.VFlex
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    paddingLeft: 10,
                    paddingRight: 10,
                }}
            >
                <NativeFlatButton
                    style={{
                        height: theme.ACTION_BUTTON_HEIGHT,
                        color: theme.themeColors.blue_300,
                        fontSize: 16,
                        fontWeight: 600,
                        background: "white",
                        borderRadius: 8,
                    }}
                    onClick={handleClickOpenHelpCenter}

                >
                    {ui.__("teamcardLinkage.match.error.button.helpCenter")}
                </NativeFlatButton>
                {/*
                  * Redirect to George is currently only supported with the client ID 'georgeclient'.
                  * As a result, the button has been removed.
                  * This decision was confirmed in discussion with Eliza and Mateo.
                  */}
                {/* <NativeFlatButton
                    style={{
                        height: theme.ACTION_BUTTON_HEIGHT,
                        color: "white",
                        fontSize: 16,
                        fontWeight: 600,
                        borderRadius: 8,
                    }}
                    onClick={handleClickFinish}
                >
                    {ui.__("teamcardLinkage.match.error.button.finish")}
                </NativeFlatButton> */}
            </pr.VFlex>
        </pr.VFlex>
    )
}

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: TeamcardLinkageStore;
}
@inject("externalInterfaceStore")
@observer
export class TeamcardLinkageMatchError extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                CustomButtonComponent={<CustomButtonComponent />}
                icon={pr.IconMessageError}
                messageComponent={
                    <div>
                        {
                            this.props.store.customErrorType === "INVALID_FIELD" ?
                                <i18n.FormattedHTMLMessage id="teamcardLinkage.error.invalidField.message" />
                                : <i18n.FormattedHTMLMessage id="teamcardLinkage.error.unmatched.message" />
                        }
                    </div>
                }
                title={ui.__("error.generic.title")}
                onDismiss={() => {
                    // pass
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageMatchError.tsx